import { useFormContext } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { taiwanCities } from '@/lib/validation';
import { AlertCircle } from 'lucide-react';

export function ShippingForm() {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // 原生 select 樣式，與 Input 元件保持一致
  const selectClassName = "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-semibold mb-4">收件人資訊</h3>
        
        {/* 姓名 */}
        <div className="space-y-2 mb-4">
          <Label htmlFor="recipient_name">姓名 *</Label>
          <Input
            id="recipient_name"
            placeholder="請輸入收件人姓名"
            {...register('recipient_name')}
            className={errors.recipient_name ? 'border-red-500' : ''}
          />
          {errors.recipient_name && (
            <p className="text-sm text-red-600 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              {errors.recipient_name.message}
            </p>
          )}
        </div>

        {/* 手機號碼 */}
        <div className="space-y-2 mb-4">
          <Label htmlFor="recipient_phone">手機號碼 *</Label>
          <Input
            id="recipient_phone"
            type="tel"
            placeholder="0912345678"
            {...register('recipient_phone')}
            className={errors.recipient_phone ? 'border-red-500' : ''}
          />
          {errors.recipient_phone && (
            <p className="text-sm text-red-600 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              {errors.recipient_phone.message}
            </p>
          )}
        </div>

        {/* Email */}
        <div className="space-y-2">
          <Label htmlFor="recipient_email">Email *</Label>
          <Input
            id="recipient_email"
            type="email"
            placeholder="example@email.com"
            {...register('recipient_email')}
            className={errors.recipient_email ? 'border-red-500' : ''}
          />
          {errors.recipient_email && (
            <p className="text-sm text-red-600 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              {errors.recipient_email.message}
            </p>
          )}
        </div>
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-4">收件地址</h3>
        
        <div className="grid grid-cols-3 gap-4 mb-4">
          {/* 縣市 - 改用原生 select 解決無窮迴圈問題 */}
          <div className="space-y-2">
            <Label htmlFor="city">縣市 *</Label>
            
            <select
              id="city"
              className={`${selectClassName} ${errors.city ? 'border-red-500' : ''}`}
              defaultValue=""
              {...register('city')}
            >
              <option value="" disabled>選擇縣市</option>
              {taiwanCities.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>

            {errors.city && (
              <p className="text-sm text-red-600 flex items-center gap-1">
                <AlertCircle className="h-3 w-3" />
                {errors.city.message}
              </p>
            )}
          </div>

          {/* 區域 */}
          <div className="space-y-2">
            <Label htmlFor="district">區域 *</Label>
            <Input
              id="district"
              placeholder="中正區"
              {...register('district')}
              className={errors.district ? 'border-red-500' : ''}
            />
            {errors.district && (
              <p className="text-sm text-red-600 flex items-center gap-1">
                <AlertCircle className="h-3 w-3" />
                {errors.district.message}
              </p>
            )}
          </div>

          {/* 郵遞區號 */}
          <div className="space-y-2">
            <Label htmlFor="zip_code">郵遞區號 *</Label>
            <Input
              id="zip_code"
              placeholder="100"
              maxLength={5}
              {...register('zip_code')}
              className={errors.zip_code ? 'border-red-500' : ''}
            />
            {errors.zip_code && (
              <p className="text-sm text-red-600 flex items-center gap-1">
                <AlertCircle className="h-3 w-3" />
                {errors.zip_code.message}
              </p>
            )}
          </div>
        </div>

        {/* 詳細地址 */}
        <div className="space-y-2 mb-4">
          <Label htmlFor="address">詳細地址 *</Label>
          <Input
            id="address"
            placeholder="請輸入街道、巷弄、樓層等詳細地址"
            {...register('address')}
            className={errors.address ? 'border-red-500' : ''}
          />
          {errors.address && (
            <p className="text-sm text-red-600 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              {errors.address.message}
            </p>
          )}
        </div>

        {/* 備註 */}
        <div className="space-y-2">
          <Label htmlFor="notes">備註（選填）</Label>
          <Textarea
            id="notes"
            placeholder="如有特殊需求或配送指示，請在此說明"
            rows={3}
            {...register('notes')}
            className={errors.notes ? 'border-red-500' : ''}
          />
          {errors.notes && (
            <p className="text-sm text-red-600 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              {errors.notes.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
